import { createSelector } from 'reselect';

import { get as _get } from 'lodash';

import { selectFirestore, selectListPendingFactory, selectItemPendingFactory } from 'services/selectors';
import { selectors as pinsSelectors } from 'modules/pins';
import { selectors as venuesSelectors } from 'modules/venues';
import { utils as uploaderUtils } from 'modules/uploader';

import { MarkerTypes } from './constants';

const selectMapsState = state => state.maps;

const selectPending = createSelector(selectMapsState, maps => maps.pending);

const selectMap = createSelector(selectMapsState, maps => maps.map);

export const selectMapActivePinId = createSelector(selectMap, map => map.activePinId);

export const selectListPending = selectListPendingFactory(selectPending);
export const selectItemPending = selectItemPendingFactory(selectPending);

export const selectPins = createSelector(
    pinsSelectors.selectPins,
    venuesSelectors.selectVenuesForMap,
    (pins, venues) => [
        ...pins.map(pin => ({ ...pin, type: MarkerTypes.PIN })),
        ...venues.map(venue => ({ ...venue, type: MarkerTypes.VENUE })),
    ],
);

export const selectImageMaps = createSelector(selectFirestore, firestore => _get(firestore, 'ordered.imageMaps', []));

export const selectUploaderImageMaps = createSelector(selectImageMaps, imageMaps =>
    imageMaps.map(({ id, image, order }) => ({
        ...uploaderUtils.imageToFile(image),
        order,
        firestoreId: id,
    })),
);
